<div class="full-width-box">
    <slot/>
</div>

<style>
    .full-width-box {
        align-self: stretch;
    }
</style>